'use strict';

angular.module('header')

.controller('ProgrammeHeaderCtrl', function ($scope, $state, kdAuth, kdLogin, programme, $rootScope)
{
    $scope.navCollapsed = true;
    $scope.kdAuth = kdAuth;
    $scope.kdLogin = kdLogin;
    $scope.programme = programme;

    var masterProgramme = programme;

    if (programme.parent) {
        masterProgramme = programme.parent;
    }

    $scope.languages = [masterProgramme];

    angular.forEach(masterProgramme.children, function (child)
    {
        if (child.language.enabled) {
            $scope.languages.push(child);
        }
    });

    $scope.showHeaderBanner = programme.header_banner;
    $scope.showHeaderBackButton = false;

    $scope.languageSwitched = function (model)
    {
        $state.go('programme', {programmeSlug: model.slug});
    };

    $rootScope.$on('$stateChangeSuccess', function(state, to)
    {
        if (to.name === "programme.category.article.page") {
            $scope.showHeaderBackButton = true;
        } else {
            $scope.showHeaderBackButton = false;
        }

        if (programme.header_banner) {
            $scope.showHeaderBanner = to.name === 'programme.contents';
        }

        $scope.navCollapsed = true;
    });
});
